import {SagaIterator} from "redux-saga";
import {all, takeLatest} from "redux-saga/effects";
import * as actions from "modules/actions";
import * as sagas from "modules/sagas";

/**
 * Root saga that connect sagas with actions.
 */
export const rootSaga = function* (): SagaIterator {
	yield all([
		/**
		 * Auth
		 */
		takeLatest(actions.backdoorLogin, sagas.userBackdoorLoginSaga),
		takeLatest(actions.userLogout, sagas.userLogoutSaga),
		takeLatest(actions.userLogin, sagas.userLoginSaga),

		/**
		 * User
		 */
		takeLatest(actions.userCreate, sagas.userCreateSaga),
		takeLatest(actions.userUpdate, sagas.userUpdateSaga),
		takeLatest(actions.userReturn, sagas.userReturnSaga),
		takeLatest(actions.userRegisterForGame, sagas.userRegisterForGameSaga),
		takeLatest(actions.userFetch, sagas.userFetchSaga),

		/**
		 * Global
		 */
		takeLatest(actions.globalError, sagas.errorsManagerSaga),

		/**
		 * JSONs
		 */
		takeLatest(actions.fetchChecksumsJSON, sagas.fetchChecksumsJSONSaga),
		takeLatest(actions.fetchConstructorsJSON, sagas.fetchConstructorsJSONSaga),
		takeLatest(actions.fetchEventsJSON, sagas.fetchEventsJSONSaga),
		takeLatest(actions.fetchRidersJSON, sagas.fetchRidersJSONSaga),
		takeLatest(actions.fetchSquadsJSON, sagas.fetchSquadsJSONSaga),
		takeLatest(actions.fetchHelpPages, sagas.fetchHelpPagesSaga),
		takeLatest(actions.fetchFaq, sagas.fetchFaqSaga),
		takeLatest(actions.fetchCountries, sagas.fetchCountriesSaga),
		takeLatest(actions.fetchPrizes, sagas.fetchPrizesSaga),
		/**
		 * Fantasy Team
		 */
		takeLatest(actions.fetchMyTeam, sagas.fetchMyTeamSaga),
		takeLatest(actions.postMyTeam, sagas.postMyTeamSaga),
		takeLatest(actions.postTeamAutoPick, sagas.postTeamAutoPickSaga),
		takeLatest(actions.setUnitToField, sagas.setUnitToFieldSaga),
		takeLatest(actions.postMakeTrades, sagas.postMakeTradesSaga),
		takeLatest(actions.postMakeReverse, sagas.postMakeReverseSaga),
		takeLatest(actions.showOverBudgetError, sagas.showOverBudgetErrorSaga),
		takeLatest(actions.getUserTeam, sagas.getUserTeamSaga),

		/**
		 * Leagues
		 */
		takeLatest(actions.fetchMyLeagues, sagas.fetchMyLeaguesSaga),
		takeLatest(actions.postLeagueCreate, sagas.postLeagueCreateSaga),
		takeLatest(actions.postLeagueUpdate, sagas.postLeagueUpdateSaga),
		takeLatest(actions.fetchLeague, sagas.fetchLeagueSaga),
		takeLatest(actions.fetchLeagueLadder, sagas.fetchLeagueLadderSaga),
		takeLatest(actions.sortLeagueLadder, sagas.sortLeagueLadderSaga),

		/**
		 * Joins
		 */
		takeLatest(actions.inviteViaEmail, sagas.postInvitesSendViaEmailSaga),
		takeLatest(actions.postLeagueLeave, sagas.postLeagueLeaveSaga),
		takeLatest(actions.fetchLeaguesForJoin, sagas.fetchLeaguesForJoinSaga),
		takeLatest(actions.postLeagueJoin, sagas.postLeagueJoinSaga),
		takeLatest(actions.searchAndJoin, sagas.searchAndJoinSaga),

		/**
		 * Contact
		 */
		takeLatest(actions.postContactForm, sagas.postContactFormSaga),

		/**
		 * Live Score
		 */
		takeLatest(actions.subscribeToLiveScores, sagas.checksumsToSaga),
	]);
};

export * from "./errors";
export * from "./user";
export * from "./jsons";
export * from "./team";
export * from "./leagues";
export * from "./contact";
export * from "./live_score";
